import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { searchQuery , feedQuery} from '../utlis/data';
import { client } from '../client';
import MasonaryLayout from './MasonaryLayout'
import Spinner from './Spinner'

const Feed = () => {
  const [loading, setLoading] = useState(false);
  const [pins, setPins] = useState(null);
  const { categoryId } = useParams();
  

  useEffect(() => {
    setLoading(true)
    if(categoryId){
      const query = searchQuery(categoryId);
      
      client.fetch(query)
        .then((data) =>{
          // console.log(data)
          setPins(data);
          setLoading(false)
        } )
    }
    else{
      client.fetch(feedQuery)
        .then((data) =>{
          setPins(data);
          // console.log(data)
          setLoading(false)
        })
      }
  
  }, [categoryId]);
  
  // console.log(pins)
  if(loading) return <Spinner message="we are adding new ideas to your feed!"/>
  if(!pins?.length) return <h2>No pins avalable</h2>
  return (
    <div className="bg-gradient-to-r from-blue-500 to-zinc-500 ">
      {
        <MasonaryLayout pins = {pins} />
      }
    </div>
)};

export default Feed;
